import React, { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import './Gallery.css';

export default function Gallery() {
  const { t } = useLang();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    fetch('/api/verunka/gallery')
      .then(r => r.json())
      .then(data => { setImages(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  const n = images.length;
  const prev = () => setIdx(i => (i - 1 + n) % n);
  const next = () => setIdx(i => (i + 1) % n);

  useEffect(() => {
    if (!n) return;
    const h = (e) => {
      if (e.key === 'ArrowLeft') setIdx(i => (i - 1 + n) % n);
      else if (e.key === 'ArrowRight') setIdx(i => (i + 1) % n);
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [n]);

  const cur = images[idx];

  return (
    <section id="gallery" className="gallery">
      <div className="gallery__inner">
        <div className="section-label">{t.gallery.title}</div>

        {loading && <p className="gallery__status">{t.gallery.loading}</p>}
        {error && <p className="gallery__status gallery__status--error">{t.gallery.error}</p>}

        {!loading && !error && cur && (
          <div className="gallery__viewer">
            <button className="gallery__nav gallery__nav--prev" onClick={prev} aria-label="Previous">&#8249;</button>

            <div className="gallery__stage">
              <div className="gallery__img-wrap">
                <img src={cur.url} alt={cur.title} />
              </div>
              <p className="gallery__caption">{cur.title}</p>
              <p className="gallery__counter">{idx + 1} / {images.length}</p>
            </div>

            <button className="gallery__nav gallery__nav--next" onClick={next} aria-label="Next">&#8250;</button>
          </div>
        )}
      </div>
    </section>
  );
}
